module.exports = "function jsx_example_hello(attrib, children) {\n  return (\n    S.create(\"div\", {\"class\": \"special\"}, [\n      S.create(\"h1\", {}, [\"Hello, World!\"]),\n      children\n    ]\n  );\n}"


//////////////////
// WEBPACK FOOTER
// ./src/slides/07_jsx/xhpjs-compiled.example
// module id = 1506
// module chunks = 0